// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__1U2Hq","lastUpdated":"PrivacyPolicy_lastUpdated__qu2LZ"};